import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getDealById } from '../services/apiService';
import './SuccessPage.css';

const CATEGORY_TITLES = {
  'Eten & Drinken': 'Eet smakelijk!',
  'Lunch':          'Eet smakelijk!',
  'Koffie':         'Genoten!',
  'Dranken':        'Proost!',
  'Mode':           'Goede keuze!',
  'Beauty':         'Verwend!',
};

const DEFAULT_TITLE = 'Deal gebruikt!';

export default function SuccessPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [deal, setDeal] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getDealById(id)
      .then((d) => { if (!cancelled) { setDeal(d); setLoading(false); } })
      .catch(() => { if (!cancelled) { setDeal(null); setLoading(false); } });
    return () => { cancelled = true; };
  }, [id]);

  if (loading) {
    return (
      <div className="success-404">
        <p>Laden…</p>
      </div>
    );
  }

  if (!deal) {
    return (
      <div className="success-404">
        <p>Pagina niet gevonden.</p>
        <button onClick={() => navigate('/feed')}>Terug naar feed</button>
      </div>
    );
  }

  const title = CATEGORY_TITLES[deal.category] || DEFAULT_TITLE;

  return (
    <div className="success">
      <div className="success__content">
        <div className="success__top">
          <div className="success__circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <h1 className="success__title">{title}</h1>
          <p className="success__subtitle">
            Je deal bij {deal.shopName} is ingeleverd. Geniet ervan!
          </p>
          <p className="success__deal-line">{deal.title}</p>
        </div>

        <button className="success__cta" onClick={() => navigate('/feed')}>
          Bekijk alle deals
        </button>
      </div>
    </div>
  );
}
